
import { defineComponent, PropType, watch } from 'vue'
import InputKin from '@/views/components/InputKin.vue'
import { TaishakuTaishoKmkType } from '@/repositories/keiei-joho/taishaku-taisho/data'
import { CorporationTypeType, corporationTypeType } from '@/views/corporation-info/types'
import { taishakuTaishoKmkTypeType as KmkType } from '@/repositories/keiei-joho/data'
import { aggregateAndSet } from '@/views/keiei-joho/taishaku-taisho/uiLogic'
import { formatNumberWithCommas } from '@/views/keiei-joho/mathUtils'

export default defineComponent({
  methods: { formatNumberWithCommas },
  components: { InputKin },
  props: {
    corporationType: {
      type: String as PropType<CorporationTypeType>
    },
    ryudoShisanItems: {
      type: Array as PropType<TaishakuTaishoKmkType[]>,
      required: true
    },
    yukeiKoteiShisanItems: {
      type: Array as PropType<TaishakuTaishoKmkType[]>,
      required: true
    },
    mukeiKoteiShisanItems: {
      type: Array as PropType<TaishakuTaishoKmkType[]>,
      required: true
    },
    otherShisanItems: {
      type: Array as PropType<TaishakuTaishoKmkType[]>,
      required: true
    },
    shisanGokei: {
      type: Object as PropType<TaishakuTaishoKmkType>,
      required: true
    },
    koteiShisanGokei: {
      type: Object as PropType<TaishakuTaishoKmkType>,
      required: true
    },
    isDisabledByCorporationType: {
      type: Function as PropType<(item: TaishakuTaishoKmkType) => boolean>,
      required: true
    }
  },
  emits: {
    updateKoteiShisanGokei: (val: number) => true,
    updateShisanGokei: (val: number) => true
  },
  setup (props, { emit }) {
    // 法人タイプ１以外の場合の自動計算
    // （流動資産、固定資産合計、有形固定資産、無形固定資産、その他の資産、資産合計）
    watch(
      [
        () => props.ryudoShisanItems.filter(v => !v.isAggregate),
        () => props.yukeiKoteiShisanItems.filter(v => !v.isAggregate),
        () => props.mukeiKoteiShisanItems.filter(v => !v.isAggregate),
        () => props.otherShisanItems.filter(v => !v.isAggregate)
      ],
      () => {
        if (props.corporationType === corporationTypeType.Type1) return

        const ryudo = aggregateAndSet(props.ryudoShisanItems, KmkType.RyudoShisan)
        const yukei = aggregateAndSet(props.yukeiKoteiShisanItems, KmkType.YukeiKoteiShisan)
        const mukei = aggregateAndSet(props.mukeiKoteiShisanItems, KmkType.MukeiKoteiShisan)
        const other = aggregateAndSet(props.otherShisanItems, KmkType.OtherShisan)
        if (props.koteiShisanGokei) {
          emit('updateKoteiShisanGokei', yukei + mukei + other)
        }
        if (props.shisanGokei) {
          emit('updateShisanGokei', ryudo + yukei + mukei + other)
        }
      },
      {
        deep: true
      }
    )

    // 法人タイプ１の場合の自動計算（固定資産合計、資産合計）
    watch(
      [
        () => props.ryudoShisanItems.find(v => v.kmkType === KmkType.RyudoShisan)?.kin ?? 0,
        () => props.yukeiKoteiShisanItems.find(v => v.kmkType === KmkType.YukeiKoteiShisan)?.kin ?? 0,
        () => props.mukeiKoteiShisanItems.find(v => v.kmkType === KmkType.MukeiKoteiShisan)?.kin ?? 0,
        () => props.otherShisanItems.find(v => v.kmkType === KmkType.OtherShisan)?.kin ?? 0
      ],
      ([ryudo, yukei, mukei, other]) => {
        if (props.corporationType !== corporationTypeType.Type1) return

        if (props.koteiShisanGokei) {
          emit('updateKoteiShisanGokei', yukei + mukei + other)
        }
        if (props.shisanGokei) {
          emit('updateShisanGokei', ryudo + yukei + mukei + other)
        }
      }
    )

    return {
      corporationTypeType
    }
  }
})
